import Script from 'next/script'
import { IConfigFile } from '../../../utils'

export default function LiveBroadcastJsonLd({
  config,
}: {
  config: IConfigFile
}) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BroadcastEvent',
    name: config.live_h_title,
    description: config.live_description,
    isLiveBroadcast: true,
    subtitleLanguage: 'עברית',
  }

  return (
    <Script
      id='LiveBroadcastJsonLdLive'
      type='application/ld+json'
      strategy='beforeInteractive'
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(jsonLd),
      }}
    />
  )
}
